import clsx from "clsx";
import {useIntl} from "react-intl";
import IKeyValue from "../core/interfaces/IKeyValue.ts";
import {ulid} from "ulid";
import Select, { MultiValue } from 'react-select'
import { useEffect } from "react";

export interface IComponent {
  fieldsProps: any;
  i18n: string;
  options: IKeyValue[],
  error?: string;
  value?: any[];
  touched?: boolean;
  hideLabel?: boolean;
  selectLabel?: string;
  disabled?: boolean;
  inputGroup?: any[];
  small?: boolean;
  onChange?: (value:any[]) => void
}

export default function (props: IComponent) {
  const intl = useIntl()


  const optionsObj = props.options.map(option => ({value:option.key, label: option.value}))

  const handleChange = (selected: MultiValue<{ value: string; label: string }> | null) => {

    const values = selected ? selected.map(option => option.value) : [];
    if(props.onChange){
      props.onChange(values)
    }
  };

  return <>
    {!props.hideLabel &&
      <label className="fs-6 fw-semibold required mb-2">{intl.formatMessage({id: props.i18n})}</label>
    }

    <Select
      className={`react-select-styled react-select-solid ${props.small ? 'react-select-sm' : 'react-select-lg'}`}
      classNamePrefix='react-select'
      options={optionsObj}
      placeholder={intl.formatMessage({id: props.i18n})}
      value={props.value ? optionsObj.filter(option => props.value?.includes(option.value) ) : []}
      onChange={handleChange}
      isMulti
      />

    {(props.touched && props.error) && (
      <div className='fv-plugins-message-container'>
        <div className='fv-help-block'>
          <span role='alert'>{props.error}</span>
        </div>
      </div>
    )}
  </>
}
